import { render, staticRenderFns } from "./WorkGroupUnitPrice.vue?vue&type=template&id=e948bd64"
import script from "./WorkGroupUnitPrice.vue?vue&type=script&lang=js"
export * from "./WorkGroupUnitPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports